
import Vue, { PropType } from "vue";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import { urlify } from "@/util/utils";
import VueSecureHTML from "vue-html-secure";
Vue.use(VueSecureHTML);

export default Vue.extend({
  name: "evacuation-alert-view",
  props: {
    displayContentI18n: {
      type: Object as PropType<PortalAdapterApi.I18nObject>,
      default: undefined,
    },
    btnAction: { type: String, default: "OK" },
  },
  computed: {
    showContent(): string | undefined {
      if (this.displayContentI18n === undefined) return "";
      const lang = this.$store.state.data.language as
        | "ja-JP"
        | "zh-TW"
        | "zh-CN"
        | "en-US"
        | "ko-KR";
      let lang2 = lang.replace("-", "_") as
        | "ja_JP"
        | "zh_TW"
        | "zh_CN"
        | "en_US"
        | "ko_KR";
      if (lang2 === undefined) lang2 = "ja_JP";

      const feedbackLang = this.displayContentI18n.fallbackLanguage as
        | "ja_JP"
        | "zh_TW"
        | "zh_CN"
        | "en_US"
        | "ko_KR";
      return this.displayContentI18n.languageList[lang2] === undefined
        ? this.displayContentI18n.languageList[feedbackLang]
        : this.displayContentI18n.languageList[lang2];
    },
    showHTMLContent(): string {
      if (this.showContent === undefined) return "";
      return urlify(this.showContent);
    },
  },
  methods: {
    okClicked() {
      this.$emit("okClicked");
    },
  },
});
